import { LinearGradient, type LinearGradientProps } from "expo-linear-gradient";
import { type ColorValue, StyleSheet } from "react-native";
import { useTheme } from "~/providers/ThemeProvider";

type BackgroundGradientProps = {
    colors?: readonly [ColorValue, ColorValue, ...ColorValue[]];
} & Omit<LinearGradientProps, "colors">;

export const BackgroundGradient = (gradientProps: BackgroundGradientProps) => {
    const { colours } = useTheme();

    return (
        <LinearGradient
            {...gradientProps}
            colors={gradientProps.colors ?? [colours.brand, colours.background.secondary]}
            style={[styles.gradient, gradientProps.style]}
        />
    );
};

const styles = StyleSheet.create({
    gradient: {
        position: "absolute",
        zIndex: 0,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
    },
});
